import pages from '../router/routes';

export const ALL_APP_ROUTES = [
  pages.home.name,
  pages.dashboard.name,
  pages.application.name,
  pages.applicationGroup.name,
  pages.accounting.name,
  pages.unallocatedDevices.name,
  pages.users.name,
  pages.reports.name,
  pages.providers.name,
  pages.integrations.name,
];

export const GROUP_CONTEXT_ROUTES = [pages.tariffs.name];

export const SELECTION_SYNC_EXCLUDED_ROUTES = [
  pages.auth.root,
  pages.status.root,
  pages.topup.root,
  pages.releaseNotes.name,
  pages.design.name,
  pages.hardware.name,
];

export const APP_CONTEXT_ROUTES = [
  pages.accounts.name,
  pages.utility.name,
  pages.meterpoints.name,
  pages.meters.name,
  pages.gateways.name,
  pages.sensors.name,
  pages.zones.name,
  pages.manualReadings.name,
  pages.payments.name,
  pages.recons.name,
  pages.map.name,
  pages.emailIntegrationLogs.name,
];
